import { Popups } from './popupsTypes';
import { MiniSurveyStateEnum } from '@inter-ikea-kompis/component-mini-survey';

const defaultState: Popups = {
  sceneErrorVisible: false,
  introPopupsVisible: false,
  hasShownIntroPopups: false,
  hasShownPegboardHint: false,
  showPegboardHint: null,
  cuttableMountingRailHintCheckPending: false,
  hasShownCuttableMountingRailHint: false,
  showCuttableMountingRailHint: null,
  cuttableMountingRailHintAlignment: null,
  showDoorsHint: null,
  hasShownExtendableConf: false,
  showExtendableConf: null,
  hasHadUserInteraction: false,
  supplyBannerClosed: false,
  hasShownFilterIntroPopup: false,
  filterIntroPopupVisible: false,
  hasShownMountingRailSheet: false,
  confDialog: {},
  overlayActive: false,
  scrollException: false,
  surveyVisible: false,
  surveyState: MiniSurveyStateEnum.default,
  errorHandlingPendingTimestamp: null,
};

export default defaultState;
